module.exports = __webpack_public_path__ + "assets/GooglePlayBadgeWhite_US.ab43147765bc23f2550f2a15d3e557d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/buttons/GooglePlayBadgeWhite_US.svg
// module id = 184
// module chunks = 0